import * as jsbarcode from 'jsbarcode';
import logger from './logger';

export const generateBarcodeImage = (text = '') => {
  const canvas = document.createElement('canvas');
  try {
    jsbarcode(canvas, text, {
      height: 30,
      width: 1.5,
      displayValue: false,
    });
  } catch (e) {
    logger.warn('error generating barcode image', e);
  }

  return canvas.toDataURL('image/png');
};
